import { Button, Colors } from 'basic-ui-lib';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import HeaderMobile from 'layouts/widgets/HeaderMobile';
import { FooterMobile } from 'layouts/widgets/BottomMobile';
import useGetDetailPlaylist from 'modules/playlist/services/hooks/useGetDetailPlaylist';
import { Form, Input } from 'antd';
import ContentPickerSectionMobile, { ContentFormValues } from 'basic-ui-lib/components/ContentPickerSectionMobile';
import playlistApis from 'modules/playlist/services/apis';
import toast from 'utils/toast';
import { getMessageError } from 'services/response';
import { useEffect } from 'react';

interface PlaylistFormValues extends ContentFormValues {
  name: string;
  storeId: string;
}

const DetailPlaylistMobile = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [data] = useGetDetailPlaylist(id || '');
  const [form] = Form.useForm<PlaylistFormValues>();

  const handleFinish = async(values: PlaylistFormValues) => {
    try {
      const res = await playlistApis.createOrUpdatePlaylist({
        id: id || '',
        name: values.name || '',
        duration: values.contentItems?.reduce((sum, item) => sum + (item?.duration || 0), 0) || 0,
        storeId: values.storeId || '',
        contentItems: values.contentItems || [],
      });
      if (res?.data?.data) {
        toast.success(`Playlist ${id ? 'updated' : 'created'} successfully`);
        navigate('/playlist');
      }
    } catch (error) {
      toast.error(getMessageError(error) || `An error occurred while ${id  ? 'updating' : 'creating'} the playlist`);
    }
  };

  useEffect(() => {
  if (data) {
    form.setFieldsValue({
      contentItems: data.contentItems || [],
      name: data.name || '',
      storeId: data.storeId || '',
    });
  }
}, [data]);

  return (
    <Container>
      <HeaderMobile title='Playlist Detail' onBack={() => navigate('/playlist')} />
      <Content>
        <Form
          form={form}
          layout='vertical'
          onFinish={handleFinish}
        >
            <Form.Item name='name' noStyle>
              <Input type='hidden' />
            </Form.Item>
            <Form.Item name='storeId' noStyle>
              <Input type='hidden' />
            </Form.Item>
            <Form.Item name='contentItems' noStyle shouldUpdate>
              <Input type='hidden' />
            </Form.Item>
          <ContentPickerSectionMobile type='PLAYLIST' />
        </Form>
      </Content>
      <FooterMobile>
        <Button type_cancel lg onClick={() => navigate('/playlist')}>
          Cancel
        </Button>
        <Button type_second lg onClick={() => form.submit()}>
          Save
        </Button>
      </FooterMobile>
    </Container>
  );
};

export default DetailPlaylistMobile;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.neutral.bg[1]};
  height: 100vh;
`;

const Content = styled.div`
  flex: 1;
  padding-top: 16px;
`;
